import { useScrollReveal } from "../useScrollReveal";
import "./Es3Story.css";

function Es3Story() {
  const { ref, fromLeft, fromRight } = useScrollReveal(0.1);

  return (
    <section className="es3-section es3-story" id="es3-story" ref={ref}>
      <div className="es3-story-split">
        <div className="es3-story-left" style={fromLeft(0)}>
          <div className="es3-hand">the premise</div>
          <h2 className="es3-h2">
            These shelves were always meant to tell stories.{" "}
            <em>We just thought they'd start with ours.</em>
          </h2>
        </div>
        <div className="es3-prose es3-story-right" style={fromRight(160)}>
          {/* <p>
            Exyst made things. Journals for the thoughts you never said out loud. Perfumes numbered one to ten. Waistcoats stitched to be kept, not replaced. Those products are gone now, and we sat with a choice. Restock the shelves ourselves, or open them to people who already had stories waiting to be seen.
          </p> */}
          <p>
            We spent months making things worth putting on these shelves. Journals for the thoughts you never said out loud. Perfumes numbered one to ten. Waistcoats cut for keeps. Then the flooding hit Lahore, and we lost everything we had prepared. 
          </p>
          {/* <p><strong>We chose everyone else.</strong></p> */}
          <p><strong>We sat with that for a while, and then we made a decision. We started over. But this time, not alone.</strong></p>
          {/* <p>
            Because the most interesting things in this country are not being made by brands. They are made in bedrooms, on rooftops, in hostel rooms and home workshops. Painted, thrown, stitched, carved and brewed by people who never had a shelf to put them on.
          </p> */}
          {/* <p>
            So this is Exyst Space. A gallery, a coffee bar, a stage and a studio under one roof. And every single thing on its walls is made by someone like you.
          </p> */}
          <p>
            Exyst Space is what came out of that reset: a gallery, a coffee bar, a live stage and a studio, built for the makers who never had a space like this.
            Now they do. 
          </p>
        </div>
      </div>
    </section>
  );
}

export default Es3Story;
